import anime from 'animejs';
import store from '../util/store';
import { isFunction } from '../functions';

export default class PageAnimation {
  constructor($old, $current, done) {
    this.$old = $old;
    this.$current = $current;
    this.done = done;

    this.headerAnimation = this.createHeaderAnimation();
    this.observableAnimations = [];
    this.observableAnimations.push(this.createContentAnimation(this.$current.querySelectorAll('.js-page-content')));
    this.observableAnimations.push(this.createTextAnimation(this.$current.querySelectorAll('.js-page-intro span')));

    const $fadeIn = Array.from(this.$current.querySelectorAll('.js-fade-in'));
    $fadeIn.map ( $el => {
      this.observableAnimations.push(this.createTextAnimation($el));
    });

    const fadedElements = Array.from(this.$current.querySelectorAll('.js-fade-content'));
    fadedElements.map( $el => this.observableAnimations.push(this.createContentAnimation($el, 1000)) );

    const $counters = Array.from(this.$current.querySelectorAll('.js-counter'));
    $counters.map ( $el => {
      this.observableAnimations.push(this.createCounterAnimation($el));
    });

    this.$current.classList.add('appear-in');

    if(this.$old) {
      this.$old.classList.add('appear-out');
    }

    this.then = setTimeout( this.onFinish.bind(this), 1000);
  }

  onFinish() {
    store.unlockBody();
    store.scrollToTop();

    this.$current.removeAttribute('data-transition-in');
    this.pushNewColor();

    if(this.$old) {
      this.$old.remove();
    }

    this.headerAnimation.play();

    if(this.done) {
      this.done();
    }
  }

  afterHeaderAnimation() {
    if(isFunction(IntersectionObserver)) {
      this.observableAnimations.map( animation => {
        let observer = new IntersectionObserver((intersections) => {
          const inter = intersections[0];
          if(inter.isIntersecting && !animation.completed) {
            animation.play();
          }
        });
        const animatables = animation.animatables[0];
        if(animatables) {
          observer.observe(animatables.target);
        }
      });
    } else {
      this.observableAnimations.map( animation => animation.play());
    }

    this.$current.classList.add('loaded');
  }

  createHeaderAnimation() {
    const $title = this.$current.querySelectorAll('.js-page-title');
    const $titleSpan = this.$current.querySelectorAll('.js-page-title span');

    let timeline = anime.timeline({autoplay: false, complete: this.afterHeaderAnimation.bind(this)});

    timeline.add({
      targets: $titleSpan,
      opacity: {
        value: [0, 1],
        duration: 100,
        easing: 'easeInOutQuart',
      },
      delay: anime.stagger(50),
    }, 0);


    timeline.add({
      targets: $title,
      borderBottom: {
        value: ['0.1rem solid rgba(0, 0, 0, 0)', '0.1rem solid rgba(255, 255, 255, 1)'],
        duration: 200,
        easing: 'easeInOutQuart',
      },
    });

    return timeline;
  }

  createTextAnimation($text) {
    return anime({
      targets: $text,
      opacity: {
        value: [0, 1],
        duration: 500,
        easing: 'easeInOutQuart',
      },
      delay: anime.stagger(50),
      autoplay: false,
    });
  }

  createContentAnimation($content, duration) {
    duration = duration || 500;
    return anime({
      targets: $content,
      translateY: {
        value: ['5rem', '0'],
        duration: duration,
        easing: 'easeOutSine',
      },
      opacity: {
        value: [0, 1],
        duration: duration,
        easing: 'easeInOutQuart',
      },
      delay: anime.stagger(50),
      autoplay: false,
    });
  }

  createCounterAnimation($element) {
    let max = parseInt($element.textContent);
    let min = store.linksCount;

    $element.textContent = min;
    store.linksCount = max;

    return anime({
      targets: $element,
      innerHTML: [min, max],
      easing: 'cubicBezier(.08278658669965, 1.05751242522212, 0, .97996504057731)',
      round: 1,
      duration: 4037,
      delay: 250,
      autoplay: false,
    });
  }

  pushNewColor() {
    const colorStyle = this.$current.querySelector('.js-color-style');
    if (!colorStyle) return;

    let style = document.createElement('style');
    style.innerHTML = colorStyle.innerHTML;

    this.$current.appendChild(style);
  }

}



// WEBPACK FOOTER //
// ./scripts/animation/PageAnimation.js